/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/display-name */
import {
    Tooltip,
    Checkbox,
    makeStyles,
    TableContainer,
    TableHead,
    Table,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Collapse,
    Radio,
    FormControlLabel,
    SwipeableDrawer,
} from '@material-ui/core';
import { Theme, createStyles } from '@material-ui/core/styles';
import { GridRowData } from '@material-ui/data-grid';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import en from '../../lang/en-us';
import { CheckBoxField } from '../CheckBoxField';
import SearchInput from '../SearchInput';
import Skeleton from '@material-ui/lab/Skeleton';
import {
    CustomToolTipProps,
    DataTableColumn as _Column,
    TableCellParams as CellParams,
    TableColumn as Column,
    TableProps,
} from './types';
import NoFoliosFound from '../../components/dashboard/makeNct/NoFoliosFound';
const { dashboard, common } = en;

export type TableColumn = Column;
export type DataTableColumn = _Column;
export type TableCellParams = CellParams;

const useStyles = makeStyles({
    tooltip: {
        backgroundColor: '#4a4a4a',
        fontSize: 14,
        color: '#ffffff',
    },
    arrow: {
        color: '#4a4a4a',
    },
    tooltipContent: {
        padding: 0,
        outline: 'none',

        '&:focus, &:focus-visible': {
            outline: '2px solid #ffffff',
            outlineOffset: '1px',
            borderRadius: '2px',
        },
    },
});

export function CustomToolTip({ children, title, ...props }: CustomToolTipProps) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [isHoveringTrigger, setIsHoveringTrigger] = React.useState(false);
    const [isHoveringTooltip, setIsHoveringTooltip] = React.useState(false);
    const [isFocused, setIsFocused] = React.useState(false);
    const tooltipId = React.useRef(`tooltip-${Math.random().toString(36).substr(2, 9)}`);
    const announcementRef = React.useRef<HTMLDivElement>(null);

    const tooltipContentRef = React.useRef<HTMLDivElement>(null);
    // Tracks whether the user explicitly dismissed the tooltip via Escape
    // while the trigger still has DOM focus. We use a ref (not state) so
    // the keydown handler sees the latest value synchronously regardless
    // of React's render batching. Reset on blur (when the user leaves the
    // trigger) so a fresh re-entry re-enables the tooltip.
    const dismissedWhileFocusedRef = React.useRef(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const announceTooltip = () => {
        // Announce to screen readers
        if (announcementRef.current && title) {
            const tooltipText = typeof title === 'string' ? title : String(title);
            announcementRef.current.textContent = tooltipText;
            // Clear the announcement after it's read
            setTimeout(() => {
                if (announcementRef.current) {
                    announcementRef.current.textContent = '';
                }
            }, 100);
        }
    };

    const handleTriggerMouseEnter = () => {
        setIsHoveringTrigger(true);
        setOpen(true);
        announceTooltip();
    };

    const handleTriggerMouseLeave = () => {
        setIsHoveringTrigger(false);
        if (!isHoveringTooltip && !isFocused) {
            setOpen(false);
        }
    };

    const handleTooltipMouseEnter = () => {
        setIsHoveringTooltip(true);
    };

    const handleTooltipMouseLeave = () => {
        setIsHoveringTooltip(false);
        if (!isHoveringTrigger && !isFocused) {
            setOpen(false);
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
        setOpen(true);
        announceTooltip();
    };

    const handleBlur = () => {
        setIsFocused(false);
        // Fresh entry should re-enable tooltip-on-Tab behavior.
        dismissedWhileFocusedRef.current = false;
        if (!isHoveringTrigger && !isHoveringTooltip) {
            setOpen(false);
        }
    };

    const dismissTooltip = () => {
        handleClose();
        setIsHoveringTrigger(false);
        setIsHoveringTooltip(false);
        setIsFocused(false);
        dismissedWhileFocusedRef.current = true;
    };

    const getNextFocusableAfterTrigger = (trigger: HTMLElement): HTMLElement | null => {
        const FOCUSABLE_SELECTOR =
            'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
            'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        const all = Array.from(document.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
            (el) => {
                if (el.closest('[role="tooltip"]')) return false;
                // skip elements that are visually hidden or disabled
                if (el.hasAttribute('disabled')) return false;
                if (el.getAttribute('aria-hidden') === 'true') return false;
                return true;
            },
        );
        const idx = all.indexOf(trigger);
        if (idx === -1) return null;
        return all[idx + 1] || null;
    };

    const findTriggerEl = (): HTMLElement | null =>
        document.querySelector<HTMLElement>(`[aria-describedby="${tooltipId.current}"]`);

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Escape') {
            dismissTooltip();
            return;
        }

        // Tab from the trigger should land the user in the tooltip content
        // first (so the tooltip text is reachable by keyboard), and a second
        // Tab continues to the next page element. The previous version of
        // this code gated this on the `open` React state, which created a
        // race: if the user Tabbed onto the trigger and Tabbed away again
        // before React committed `open: true`, the interception did not run
        // and focus skipped past the tooltip non-deterministically.
        //
        // Instead, we always intercept forward-Tab here, force-open the
        // tooltip, and focus the tooltip content as soon as it is in the
        // DOM (immediately if already rendered, otherwise on the next
        // animation frame after React commits the open state). Shift+Tab is
        // left to native browser handling so reverse navigation works.
        //
        // Exception: if the user just dismissed the tooltip with Escape
        // while still focused on the trigger, do NOT re-route Tab into the
        // tooltip — respect the dismissal and let Tab move to the next
        // element normally.
        if (e.key === 'Tab' && !e.shiftKey) {
            if (dismissedWhileFocusedRef.current) {
                return;
            }
            e.preventDefault();
            if (tooltipContentRef.current) {
                tooltipContentRef.current.focus();
                return;
            }
            setIsFocused(true);
            setOpen(true);
            requestAnimationFrame(() => {
                tooltipContentRef.current?.focus();
            });
        }
    };

    const handleTooltipKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Escape') {
            dismissTooltip();
            const trigger = findTriggerEl();
            trigger?.focus();
            return;
        }
        if (e.key !== 'Tab') return;
        e.preventDefault();
        const trigger = findTriggerEl();
        if (e.shiftKey) {
            // Shift+Tab from the tooltip text returns focus to the trigger.
            trigger?.focus();
        } else {
            // Forward Tab from the tooltip text closes the tooltip and
            // continues tab navigation from where the trigger left off.
            dismissTooltip();
            const next = trigger ? getNextFocusableAfterTrigger(trigger) : null;
            next?.focus();
        }
    };

    React.useEffect(() => {
        if (!open) return;
        const onDocKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                dismissTooltip();
            }
        };
        document.addEventListener('keydown', onDocKeyDown);
        return () => document.removeEventListener('keydown', onDocKeyDown);
    }, [open]);

    const shouldStayOpen = isHoveringTrigger || isHoveringTooltip || isFocused;

    if (!title) {
        return children as React.ReactElement;
    }

    // Compose any existing handler on the child with the tooltip's handler so
    // wrapping a focusable element (like <a>) does not silently drop its
    // onKeyDown / onFocus / onBlur etc. The tooltip handler runs after the
    // child's own handler so e.preventDefault() in the child still works.
    const compose =
        <E,>(childFn?: (e: E) => void, ttFn?: (e: E) => void) =>
        (e: E) => {
            childFn?.(e);
            ttFn?.(e);
        };

    const existing = (children as React.ReactElement).props || {};

    const child = React.cloneElement(children as React.ReactElement, {
        onMouseEnter: compose(existing.onMouseEnter, handleTriggerMouseEnter),
        onMouseLeave: compose(existing.onMouseLeave, handleTriggerMouseLeave),
        onFocus: compose(existing.onFocus, handleFocus),
        onBlur: compose(existing.onBlur, handleBlur),
        onKeyDown: compose(existing.onKeyDown, handleKeyDown),
        'aria-labelledby': open ? tooltipId.current : undefined,
        'aria-describedby': open ? tooltipId.current : undefined,
    });

    const tooltipContent = (
        <div
            ref={tooltipContentRef}
            id={tooltipId.current}
            role="tooltip"
            onMouseEnter={handleTooltipMouseEnter}
            onMouseLeave={handleTooltipMouseLeave}
            onFocus={handleTooltipMouseEnter}
            onBlur={handleTooltipMouseLeave}
            onKeyDown={handleTooltipKeyDown}
            tabIndex={0}
            className={classes.tooltipContent}
        >
            <span>{title}</span>
        </div>
    );

    return (
        <>
            {/* Screen reader announcement element */}
            <div
                ref={announcementRef}
                role="status"
                aria-live="polite"
                aria-atomic="true"
                style={{
                    position: 'absolute',
                    left: '-10000px',
                    width: '1px',
                    height: '1px',
                    overflow: 'hidden',
                }}
            />
            <Tooltip
                {...props}
                title={tooltipContent}
                classes={classes}
                interactive
                arrow
                open={shouldStayOpen ? open : false}
                onOpen={handleOpen}
                onClose={handleClose}
                disableFocusListener={true}
                disableHoverListener={true}
                disableTouchListener={true}
            >
                {child}
            </Tooltip>
        </>
    );
}

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    tooltipTrigger: {
        '&:focus-visible': {
            outline: '2px solid #2D218A',
            outlineOffset: '2px',
            borderRadius: '4px',
        },
    },
});

export function TableWithCollapse({
    rows,
    columns: _columns,
    radioGroupsEnabled = false,
    isCollapse = false,
    renderCollapse,
    checkBoxEnabled = false,
    toolTipDescription = '',
    selectedRows = [],
    setSelectedRows = () => {},
    disableAllSelection = false,
    filterType = null,
    filteredData = {},
    setFilterType = () => {},
    setFilteredData = () => {},
    isCheckBoxSelectable = true,
    resetFilters = () => {},
    enableSearch,
    notFoundMessage,
    ...props
}: TableProps) {
    const classes = useRowStyles();
    const columns = useMemo(() => _columns.filter((column) => !column.isFilter), [_columns]);
    const filterColumns = useMemo(
        () => _columns.filter((column) => !!column.filterBy || !!column.isFilter),
        [_columns],
    );
    const isRowsLoading = useMemo(() => columns.some((column) => !!column.Cell), [columns]);
    const [announcement, setAnnouncement] = useState<string>('');

    const MobileRow = ({ row, index }: { row: GridRowData; index: number }) => {
        const [collapse, setCollapse] = useState<boolean>(isCollapse);
        const isSelected = Boolean(selectedRows.find((_row) => _row.id === row.id));
        return (
            <div
                className={row.isDisabled ? `mobile-table-outer disabled` : 'mobile-table-outer'}
                onClick={_onRowSelected(row, !isSelected)}
                key={row.id}
                aria-rowindex={index + 1}
                role="row"
            >
                {isRowsLoading ? (
                    <TableCell>
                        <Skeleton
                            height={18}
                            width={18}
                            variant={checkBoxEnabled ? 'rect' : 'circle'}
                        />
                    </TableCell>
                ) : (
                    <>
                        {checkBoxEnabled && (
                            <CustomToolTip
                                title={
                                    !!props.toolTipTextGetter &&
                                    typeof props.toolTipTextGetter === 'function'
                                        ? props.toolTipTextGetter({ row, checked: isSelected })
                                        : toolTipDescription
                                }
                                placement="right"
                            >
                                <span
                                    tabIndex={
                                        row.isDisabled || !isCheckBoxSelectable ? 0 : undefined
                                    }
                                    aria-disabled={
                                        row.isDisabled || !isCheckBoxSelectable ? true : undefined
                                    }
                                    className={
                                        row.isDisabled || !isCheckBoxSelectable
                                            ? classes.tooltipTrigger
                                            : undefined
                                    }
                                    style={
                                        row.isDisabled || !isCheckBoxSelectable
                                            ? { display: 'inline-block' }
                                            : undefined
                                    }
                                >
                                    <Checkbox
                                        checked={isSelected}
                                        disabled={row.isDisabled || !isCheckBoxSelectable}
                                        inputProps={{
                                            'aria-label': `Folio ${
                                                row.folio || row.id || index + 1
                                            }. ${isSelected ? 'Selected' : 'Not selected'}, ${
                                                index + 1
                                            } of ${filteredRows.length}.`,
                                        }}
                                    />
                                </span>
                            </CustomToolTip>
                        )}
                        {radioGroupsEnabled && (
                            <CustomToolTip
                                title={
                                    !!props.toolTipTextGetter &&
                                    typeof props.toolTipTextGetter === 'function'
                                        ? props.toolTipTextGetter({ row, checked: isSelected })
                                        : toolTipDescription
                                }
                                placement="right"
                            >
                                <label
                                    tabIndex={
                                        row.isDisabled || !isCheckBoxSelectable ? 0 : undefined
                                    }
                                    aria-disabled={
                                        row.isDisabled || !isCheckBoxSelectable ? true : undefined
                                    }
                                    className={
                                        row.isDisabled || !isCheckBoxSelectable
                                            ? classes.tooltipTrigger
                                            : undefined
                                    }
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Radio
                                        disabled={row.isDisabled || !isCheckBoxSelectable}
                                        onChange={() => {
                                            setSelectedRows([row]);
                                            setAnnouncement(
                                                `Folio ${
                                                    row.folio || row.id || index + 1
                                                } selected`,
                                            );
                                        }}
                                        checked={isSelected}
                                        inputProps={{
                                            'aria-label': `Select Folio ${
                                                row.folio || row.id || index + 1
                                            }`,
                                            'aria-setsize': filteredRows.length,
                                            'aria-posinset': index + 1,
                                            tabIndex: 0,
                                        }}
                                    />
                                </label>
                            </CustomToolTip>
                        )}
                    </>
                )}
                <div className="mobile-table-content">
                    {columns.map(
                        (
                            { renderCell, field, valueGetter, Cell, fullWidth = false, ...column },
                            _index,
                        ) => {
                            const value = row[`${field}`];
                            const GridParams: TableCellParams = {
                                row,
                                id: row.id,
                                value,
                                colDef: { field, ...column },
                                setCollapse,
                                collapse,
                                index,
                            };
                            return (
                                <div
                                    key={`${index + _index}`}
                                    className={`mobile-table-info ${
                                        _index === 0 ? 'mobile-table-straight' : ''
                                    } ${
                                        field === 'amcName' || fullWidth ? 'mobile-table-full' : ''
                                    }`}
                                >
                                    <p className="label" id={`mobile-header-${field}`}>
                                        {column.headerName || field || 'Column'}
                                    </p>
                                    <p className="value" aria-labelledby={`mobile-header-${field}`}>
                                        {Cell
                                            ? Cell
                                            : renderCell
                                            ? renderCell(GridParams)
                                            : valueGetter
                                            ? valueGetter(GridParams)
                                            : value}
                                    </p>
                                </div>
                            );
                        },
                    )}
                    <div className="mobile-table-collapse-outer">
                        <Collapse
                            in={collapse}
                            timeout="auto"
                            unmountOnExit
                            style={{ padding: '13px 20px' }}
                        >
                            {renderCollapse ? (
                                <div className="mobile-table-collapse">
                                    {renderCollapse({ row, setCollapse })}
                                </div>
                            ) : (
                                <React.Fragment />
                            )}
                        </Collapse>
                    </div>
                </div>
            </div>
        );
    };

    const DataRow = ({ row, index }: { row: GridRowData; index: number }) => {
        const [collapse, setCollapse] = useState<boolean>(isCollapse);
        const isSelected = Boolean(selectedRows.find((_row) => _row.id === row.id));
        const renderRow = useMemo(() => {
            return columns.map(
                ({ renderCell, field, valueGetter, Cell, ...column }, _index: number) => {
                    const value = row[`${field}`];
                    const GridParams: TableCellParams = {
                        row,
                        id: row.id,
                        value,
                        colDef: { field, ...column },
                        setCollapse,
                        index,
                        collapse,
                    };
                    return Cell ? (
                        <TableCell
                            className={column.className}
                            key={field + index + _index}
                            headers={`header-${field}`}
                        >
                            {Cell}
                        </TableCell>
                    ) : renderCell ? (
                        <TableCell
                            className={column.className}
                            key={field + index + _index}
                            headers={`header-${field}`}
                        >
                            {renderCell(GridParams)}
                        </TableCell>
                    ) : (
                        <TableCell
                            className={column.className}
                            key={field + index + _index}
                            headers={`header-${field}`}
                        >
                            {valueGetter ? valueGetter(GridParams) : value}
                        </TableCell>
                    );
                },
            );
        }, [row, collapse, index]);
        return (
            <>
                <TableRow
                    className={`${classes.root} ${row.isDisabled ? 'disabledCell' : ''}`}
                    aria-rowindex={index + 1}
                >
                    {(radioGroupsEnabled || checkBoxEnabled) &&
                        (isRowsLoading ? (
                            <TableCell headers="header-row-selection">
                                <Skeleton
                                    height={18}
                                    width={18}
                                    variant={checkBoxEnabled ? 'rect' : 'circle'}
                                />
                            </TableCell>
                        ) : (
                            <TableCell headers="header-row-selection" aria-label="Selection">
                                {checkBoxEnabled ? (
                                    props.toolTipEnabled ? (
                                        <CustomToolTip
                                            title={
                                                !!props.toolTipTextGetter &&
                                                typeof props.toolTipTextGetter === 'function'
                                                    ? props.toolTipTextGetter({
                                                          row,
                                                          checked: isSelected,
                                                      })
                                                    : toolTipDescription
                                            }
                                            placement="right"
                                        >
                                            <span
                                                tabIndex={
                                                    row.isDisabled || !isCheckBoxSelectable
                                                        ? 0
                                                        : undefined
                                                }
                                                aria-disabled={
                                                    row.isDisabled || !isCheckBoxSelectable
                                                        ? true
                                                        : undefined
                                                }
                                                className={
                                                    row.isDisabled || !isCheckBoxSelectable
                                                        ? classes.tooltipTrigger
                                                        : undefined
                                                }
                                                style={
                                                    row.isDisabled || !isCheckBoxSelectable
                                                        ? { display: 'inline-block' }
                                                        : undefined
                                                }
                                            >
                                                <Checkbox
                                                    onChange={_onRowSelected(row, !isSelected)}
                                                    checked={isSelected}
                                                    disabled={
                                                        row.isDisabled || !isCheckBoxSelectable
                                                    }
                                                    inputProps={{
                                                        'aria-label': `Folio ${
                                                            row.folio || row.id || index + 1
                                                        }. ${
                                                            isSelected ? 'Selected' : 'Not selected'
                                                        }, ${index + 1} of ${filteredRows.length}.`,
                                                    }}
                                                />
                                            </span>
                                        </CustomToolTip>
                                    ) : (
                                        <Checkbox
                                            disabled={row.isDisabled || !isCheckBoxSelectable}
                                            onChange={_onRowSelected(row, !isSelected)}
                                            checked={isSelected}
                                            inputProps={{
                                                'aria-label': `Folio ${
                                                    row.folio || row.id || index + 1
                                                }. ${isSelected ? 'Selected' : 'Not selected'}, ${
                                                    index + 1
                                                } of ${filteredRows.length}.`,
                                            }}
                                        />
                                    )
                                ) : props.toolTipEnabled ? (
                                    <CustomToolTip
                                        title={
                                            !!props.toolTipTextGetter &&
                                            typeof props.toolTipTextGetter === 'function'
                                                ? props.toolTipTextGetter({
                                                      row,
                                                      checked: isSelected,
                                                  })
                                                : toolTipDescription
                                        }
                                        placement="right"
                                    >
                                        <span
                                            tabIndex={
                                                row.isDisabled || !isCheckBoxSelectable
                                                    ? 0
                                                    : undefined
                                            }
                                            aria-disabled={
                                                row.isDisabled || !isCheckBoxSelectable
                                                    ? true
                                                    : undefined
                                            }
                                            className={
                                                row.isDisabled || !isCheckBoxSelectable
                                                    ? classes.tooltipTrigger
                                                    : undefined
                                            }
                                            style={
                                                row.isDisabled || !isCheckBoxSelectable
                                                    ? { display: 'inline-block' }
                                                    : undefined
                                            }
                                        >
                                            <Radio
                                                onChange={() => {
                                                    setSelectedRows([row]);
                                                    setAnnouncement(
                                                        `Folio ${
                                                            row.folio || row.id || index + 1
                                                        } selected`,
                                                    );
                                                }}
                                                checked={isSelected}
                                                disabled={row.isDisabled || !isCheckBoxSelectable}
                                                inputProps={{
                                                    'aria-label': `Select Folio ${
                                                        row.folio || row.id || index + 1
                                                    }`,
                                                    'aria-setsize': filteredRows.length,
                                                    'aria-posinset': index + 1,
                                                    tabIndex: 0,
                                                }}
                                            />
                                        </span>
                                    </CustomToolTip>
                                ) : (
                                    <Radio
                                        onChange={() => {
                                            setSelectedRows([row]);
                                            setAnnouncement(
                                                `Folio ${
                                                    row.folio || row.id || index + 1
                                                } selected`,
                                            );
                                        }}
                                        checked={isSelected}
                                        disabled={row.isDisabled || !isCheckBoxSelectable}
                                        inputProps={{
                                            'aria-label': `Select Folio ${
                                                row.folio || row.id || index + 1
                                            }`,
                                            'aria-setsize': filteredRows.length,
                                            'aria-posinset': index + 1,
                                            tabIndex: 0,
                                        }}
                                    />
                                )}
                            </TableCell>
                        ))}
                    {renderRow}
                </TableRow>
                {useMemo(
                    () => (
                        <TableRow aria-hidden={!collapse}>
                            <TableCell
                                className="collapsible-row"
                                style={{ padding: !collapse ? '0' : '0 20px 20px' }}
                                colSpan={columns.length + 1}
                            >
                                <Collapse
                                    in={collapse}
                                    timeout="auto"
                                    unmountOnExit
                                    style={{ padding: '13px 20px' }}
                                >
                                    {renderCollapse ? (
                                        renderCollapse({ row, setCollapse })
                                    ) : (
                                        <div></div>
                                    )}
                                </Collapse>
                            </TableCell>
                        </TableRow>
                    ),
                    [collapse, setCollapse, renderCollapse, columns, row],
                )}
            </>
        );
    };

    const _onRowSelected = (row: GridRowData, checked: boolean) => (e: any) => {
        if (row.isDisabled) return;
        if (radioGroupsEnabled) {
            setSelectedRows([row]);
            setAnnouncement(`Folio ${row.folio || row.id || 'row'} selected`);
            return;
        }
        const isSelectable =
            !!props.isRowSelectable && typeof props.isRowSelectable === 'function'
                ? props.isRowSelectable({ row, checked })
                : true;
        if (isSelectable) {
            setSelectedRows((prev: GridRowData[]) => {
                const newSelection = checked
                    ? [...prev, row]
                    : prev.filter((_row: GridRowData) => _row.id !== row.id);
                setAnnouncement(
                    `Folio ${row.folio || row.id || 'row'} ${checked ? 'selected' : 'deselected'}`,
                );
                return newSelection;
            });
        }
    };

    const _onColumnHeaderClick = (isAllSelected: boolean) => {
        if (!isCheckBoxSelectable) return;
        setSelectedRows(() => (isAllSelected ? rows.filter((row) => !row.isDisabled) : []));
        setAnnouncement(isAllSelected ? 'All rows selected' : 'All rows deselected');
        if (!!props.onColumnHeaderClick && typeof props.onColumnHeaderClick === 'function') {
            props.onColumnHeaderClick({ isSelected: isAllSelected });
        }
    };

    const SelectAllCheckBox = () => {
        const isAllSelected =
            filteredRows.length > 0 && selectedRows.length === filteredRows.length;
        return (
            <Checkbox
                checked={isAllSelected}
                indeterminate={selectedRows.length > 0 && selectedRows.length < filteredRows.length}
                onChange={() => _onColumnHeaderClick(!isAllSelected)}
                inputProps={{ 'aria-label': 'Select all rows' }}
            />
        );
    };

    const filteredRows = useMemo(() => {
        const filterKeys = Object.keys(filteredData).filter((key) => key !== 'searchKey');
        const filtredRowData = rows.reduce((prev: GridRowData[], currRow) => {
            const valid = filterKeys.every((_key) => {
                const _filterData = filteredData[_key] || [];
                const value =
                    typeof currRow[_key] === 'string'
                        ? currRow[_key]?.toString()?.toLowerCase()
                        : currRow[_key];
                if (!_filterData.length) return true;
                if (_key === 'assetType') {
                    let other = false;
                    let assetTypes = typeof value === 'string' ? [value?.toUpperCase()] : value;
                    if (_filterData.includes('other')) {
                        other = assetTypes?.every((assetType: string) => {
                            const _assetType = assetType?.toUpperCase();
                            return !(
                                _assetType === 'EQUITY' ||
                                _assetType === 'DEBT' ||
                                _assetType === 'LIQUID'
                            );
                        });
                    }
                    return (
                        _filterData.some((_assetType: string) =>
                            assetTypes?.includes(_assetType?.toUpperCase()),
                        ) || other
                    );
                }
                return _filterData.includes(value);
            });
            return valid ? [...prev, currRow] : prev;
        }, []);
        return filteredData.searchKey
            ? filtredRowData.filter((row) =>
                  row?.amcName?.toLowerCase()?.includes(filteredData?.searchKey?.toLowerCase()),
              )
            : filtredRowData;
    }, [rows, filteredData]);

    return (
        <div
            className="curved-table-content"
            style={{ width: '100%' }}
            tabIndex={0}
            aria-label="Data table"
        >
            <div
                role="status"
                aria-live="polite"
                aria-atomic="true"
                style={{
                    position: 'absolute',
                    left: '-10000px',
                    width: '1px',
                    height: '1px',
                    overflow: 'hidden',
                }}
            >
                {announcement}
            </div>
            {filterColumns.length ? (
                <TableFilters
                    rows={rows}
                    columns={filterColumns}
                    filteredData={filteredData}
                    filterType={filterType}
                    setFilterType={setFilterType}
                    setFilteredData={setFilteredData}
                    resetFilters={resetFilters}
                    enableSearch={enableSearch}
                    filteredRows={filteredRows}
                />
            ) : (
                <React.Fragment />
            )}
            <div
                className="curved-table-content-bottom"
                style={{ width: '100%' }}
                role={radioGroupsEnabled ? 'radiogroup' : checkBoxEnabled ? 'group' : undefined}
                aria-label={
                    radioGroupsEnabled || checkBoxEnabled
                        ? `Row selection. ${filteredRows.length} ${
                              filteredRows.length === 1 ? 'row' : 'rows'
                          }.`
                        : undefined
                }
            >
                {!!filteredRows.length ? (
                    <TableContainer style={{ maxHeight: 400 }} component={Paper}>
                        <Table
                            aria-label={`Data table with ${filteredRows.length} rows, ${columns.length} columns`}
                            aria-rowcount={filteredRows.length}
                            stickyHeader
                        >
                            <TableHead>
                                <TableRow>
                                    {radioGroupsEnabled && (
                                        <TableCell scope="col" id="header-row-selection">
                                            Select
                                        </TableCell>
                                    )}
                                    {checkBoxEnabled && !disableAllSelection && (
                                        <TableCell scope="col" id="header-row-selection">
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 4,
                                                }}
                                            >
                                                <SelectAllCheckBox />
                                                <span>Select all</span>
                                            </div>
                                        </TableCell>
                                    )}
                                    {checkBoxEnabled && disableAllSelection && (
                                        <TableCell scope="col" id="header-row-selection">
                                            Select
                                        </TableCell>
                                    )}
                                    {columns.map((header: TableColumn, _index: number) => {
                                        const headerText =
                                            header.headerName || header.field || 'Details';
                                        return (
                                            <TableCell
                                                style={{ minWidth: header.width }}
                                                key={_index}
                                                scope="col"
                                                id={`header-${header.field || _index}`}
                                            >
                                                {headerText}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredRows.map((row: any, index: number) => (
                                    <DataRow key={index} row={row} index={index} />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <NoFoliosFound info={notFoundMessage || common.noFoliosFound} />
                )}
                <div className="mobile-table">
                    {filteredRows.map((row, index) => (
                        <MobileRow key={index} row={row} index={index} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export function TableFilters({
    columns = [],
    rows = [],
    filterType = null,
    filteredData = {},
    setFilteredData = () => {},
    setFilterType = () => {},
    resetFilters,
    enableSearch = true,
    filteredRows = [],
}: {
    columns: TableColumn[];
    rows: GridRowData[];
    setFilterType: Function;
    setFilteredData: Function;
    filterType: string | null;
    filteredData: any;
    resetFilters: Function;
    enableSearch?: boolean;
    filteredRows?: GridRowData[];
}) {
    const [openDrawer, setDrawer] = useState<boolean>(false);
    const dropdownRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
    // Track each trigger button so Escape can restore focus to the one that
    // opened the dropdown (WCAG 2.4.3 Focus Order).
    const triggerRefs = useRef<{ [key: string]: HTMLAnchorElement | null }>({});
    const [searchAnnouncement, setSearchAnnouncement] = useState<string>('');
    const isFirstAnnouncementRun = useRef<boolean>(true);

    // WCAG 1.4.13 / 2.1.1: allow Escape to dismiss an open filter dropdown
    // (Fund House, Category, etc.) without forcing the user to select an
    // option. Listener is only attached while a dropdown is open.
    useEffect(() => {
        if (!filterType) return;
        const onDocKeyDown = (e: KeyboardEvent) => {
            if (e.key !== 'Escape') return;
            const triggerEl = triggerRefs.current[filterType];
            setFilterType('');
            setDrawer(false);
            triggerEl?.focus();
        };
        document.addEventListener('keydown', onDocKeyDown);
        return () => document.removeEventListener('keydown', onDocKeyDown);
    }, [filterType, setFilterType]);

    useEffect(() => {
        if (!enableSearch) return;
        if (isFirstAnnouncementRun.current) {
            isFirstAnnouncementRun.current = false;
            return;
        }
        const rawSearchKey = (filteredData['searchKey'] || '').toString();
        const searchKey = rawSearchKey.trim();
        const count = filteredRows.length;
        const noun = count === 1 ? 'result' : 'results';
        const message = searchKey
            ? `${count} ${noun} found for "${searchKey}"`
            : `${count} ${noun} found`;
        const debounceTimer = window.setTimeout(() => {
            setSearchAnnouncement('');
            window.setTimeout(() => setSearchAnnouncement(message), 30);
        }, 300);
        return () => window.clearTimeout(debounceTimer);
    }, [filteredData, filteredRows.length, enableSearch]);

    const focusFirstOption = useCallback((fieldKey: string) => {
        const el = dropdownRefs.current[fieldKey];
        const firstCheckbox = el?.querySelector(
            'input[type="checkbox"]',
        ) as HTMLInputElement | null;
        firstCheckbox?.focus();
    }, []);

    const expandAndFocus = useCallback(
        (fieldKey: string) => {
            const isOpening = filterType !== fieldKey;
            setDrawer(true);
            setFilterType((type: string) => (type === fieldKey ? '' : fieldKey));
            if (isOpening) {
                window.requestAnimationFrame(() => focusFirstOption(fieldKey));
            }
        },
        [filterType, setFilterType, focusFirstOption],
    );

    const _handleChange = (fieldKey: string, _ele: string) => {
        const fieldData = filteredData[fieldKey] || [];
        const index = fieldData.findIndex((ele: any) => ele === _ele);
        const _filteredData =
            index === -1
                ? { ...filteredData, [fieldKey]: [...fieldData, _ele] }
                : { ...filteredData, [fieldKey]: fieldData.filter((ele: any) => ele !== _ele) };
        setFilteredData(_filteredData);
    };

    const onRemoveFilter = (field: string, ele: string) => () => {
        const fieldData: string[] = filteredData[field];
        const _filterData = {
            ...filteredData,
            [field]: fieldData.filter((_ele: string) => _ele !== ele),
        };
        setFilteredData(_filterData);
    };

    const FilterChips = () => {
        return Object.keys(filteredData)
            .filter((key) => key !== 'searchKey')
            .map((_key: string, _index: number) =>
                filteredData[_key].map((_ele: string, _index1: number) => (
                    <span key={_index + _index1}>
                        {_ele}
                        <img
                            src="/images/close-black.svg"
                            alt=""
                            onClick={onRemoveFilter(_key, _ele)}
                        />
                    </span>
                )),
            );
    };

    const onClear = () => {
        resetFilters();
    };

    return (
        <div className="curved-table-content-filters">
            <style>
                {`
                    .curved-table-content-filters .curved-table-content-top {
                        flex-wrap: wrap;
                    }
                    .curved-table-content-filters .curved-table-content-top
                        > .curved-table-filter-panel {
                        order: 1;
                        flex-basis: 100%;
                        min-width: 0;
                        margin-left: -30px;
                        margin-right: -30px;
                    }
                    .curved-table-filters-dropdown-inner {
                        overflow: visible !important;
                        padding-top: 4px !important;
                        padding-bottom: 4px !important;
                    }
                    .curved-table-filter-panel .MuiCheckbox-root.Mui-focusVisible,
                    .curved-table-filter-panel .MuiCheckbox-root:focus-within {
                        outline: 2px solid #2D218A !important;
                        outline-offset: -2px !important;
                        background-color: rgba(45, 33, 138, 0.10) !important;
                        border-radius: 4px !important;
                    }
                    .curved-table-filter-panel .MuiCheckbox-root:hover {
                        outline: none !important;
                    }
                    /* Visible keyboard focus on per-row selection radios */
                    .curved-table-content-bottom .MuiRadio-root.Mui-focusVisible,
                    .curved-table-content-bottom .MuiRadio-root:focus-within {
                        outline: 2px solid #2D218A !important;
                        outline-offset: 2px !important;
                        background-color: rgba(45, 33, 138, 0.10) !important;
                        border-radius: 50% !important;
                    }
                    .curved-table-content-bottom .MuiRadio-root:hover {
                        outline: none !important;
                    }
                    .curved-table-filters-remove a:focus-visible {
                        outline: 2px solid #2D218A;
                        outline-offset: 2px;
                        border-radius: 2px;
                    }
                    /* Remove ripple effect on keyboard focus */
                    .MuiTouchRipple-root {
                        display: none !important;
                    }
                    .MuiButtonBase-root:focus .MuiTouchRipple-root {
                        display: none !important;
                    }
                    input[type="checkbox"]:focus + .MuiIconButton-label .MuiTouchRipple-root,
                    input[type="radio"]:focus + .MuiIconButton-label .MuiTouchRipple-root {
                        display: none !important;
                    }
                    .MuiCheckbox-root:focus .MuiTouchRipple-root,
                    .MuiRadio-root:focus .MuiTouchRipple-root {
                        display: none !important;
                    }
                    /* Disable ripple for keyboard interactions only */
                    .MuiCheckbox-root:not(:hover):focus .MuiTouchRipple-root,
                    .MuiRadio-root:not(:hover):focus .MuiTouchRipple-root {
                        display: none !important;
                    }
                `}
            </style>
            <div className="curved-table-content-top">
                <p>
                    <img src="/images/filters.svg" alt="" aria-hidden="true" />
                    {dashboard.ChangeDividend.filters} :
                </p>
                {columns.map((column, index) => {
                    const fieldKey = column.filterKey || column.field;
                    const isExpanded = filterType === fieldKey && openDrawer;
                    const dataWithDuplicatedValueKeys = rows.map((row) => row[fieldKey]);
                    const data = dataWithDuplicatedValueKeys.reduce((prev, curr) => {
                        if (!prev.includes(curr)) return [...prev, curr];
                        return prev;
                    }, []);
                    const values = column.renderStaticFilters?.length
                        ? column.renderStaticFilters
                        : data;
                    const filterLabel =
                        column.filterHeader || column.headerName || fieldKey || 'Filter options';
                    return (
                        <React.Fragment key={index}>
                            <a
                                ref={(el) => {
                                    triggerRefs.current[fieldKey] = el;
                                }}
                                role="button"
                                aria-expanded={isExpanded ? 'true' : 'false'}
                                aria-controls={`filter-dropdown-${fieldKey}`}
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        expandAndFocus(fieldKey);
                                    }
                                }}
                                onClick={() => expandAndFocus(fieldKey)}
                                className={isExpanded ? 'active' : ''}
                            >
                                <span>
                                    {column.filterHeader ||
                                        column.headerName ||
                                        fieldKey ||
                                        'Filter'}
                                    <img
                                        src={
                                            isExpanded
                                                ? '/images/up-arrow-purple.svg'
                                                : '/images/down-arrow-black.svg'
                                        }
                                        alt=""
                                        aria-hidden="true"
                                    />
                                </span>
                            </a>
                            <div
                                id={`filter-dropdown-${fieldKey}`}
                                className="curved-table-filter-panel"
                            >
                                <Collapse
                                    in={filterType === fieldKey}
                                    className="desktop_mode"
                                    mountOnEnter
                                    unmountOnExit
                                >
                                    <fieldset
                                        className="curved-table-filters-dropdown fieldset-focus-fix"
                                        style={{ border: 'none', padding: 0, margin: 20 }}
                                    >
                                        <legend
                                            style={{
                                                position: 'absolute',
                                                width: '1px',
                                                height: '1px',
                                                padding: 0,
                                                margin: '1px',
                                                overflow: 'hidden',
                                                clip: 'rect(0,0,0,0)',
                                                whiteSpace: 'nowrap',
                                                border: 0,
                                            }}
                                        >
                                            {filterLabel}
                                        </legend>
                                        <div
                                            ref={(el) => {
                                                dropdownRefs.current[fieldKey] = el;
                                            }}
                                            className="curved-table-filters-dropdown-inner"
                                            tabIndex={-1}
                                            aria-label={`${filterLabel} filter options`}
                                        >
                                            {values.map((_ele: string, idx: number) => (
                                                <CheckBoxField
                                                    key={idx}
                                                    label={_ele}
                                                    onChange={() =>
                                                        _handleChange(
                                                            fieldKey,
                                                            _ele?.toString()?.toLowerCase(),
                                                        )
                                                    }
                                                    value={(filteredData[fieldKey] || [])?.includes(
                                                        _ele?.toString()?.toLowerCase(),
                                                    )}
                                                    setSize={values.length}
                                                    posInSet={idx + 1}
                                                />
                                            ))}
                                        </div>
                                    </fieldset>
                                </Collapse>
                            </div>
                            <SwipeableDrawer
                                anchor={'bottom'}
                                open={
                                    filterType === (column.filterKey || column.field) && openDrawer
                                }
                                onClose={() => {
                                    setFilterType('');
                                    setDrawer(false);
                                }}
                                onOpen={() => {}}
                                className="mobile_mode"
                                SlideProps={{
                                    onEntered: () => focusFirstOption(fieldKey),
                                }}
                            >
                                <fieldset
                                    className="curved-table-filters-dropdown fieldset-focus-fix"
                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                >
                                    <legend
                                        style={{
                                            position: 'absolute',
                                            width: '1px',
                                            height: '1px',
                                            padding: 0,
                                            margin: '-1px',
                                            overflow: 'hidden',
                                            clip: 'rect(0,0,0,0)',
                                            whiteSpace: 'nowrap',
                                            border: 0,
                                        }}
                                    >
                                        {filterLabel}
                                    </legend>
                                    <div
                                        ref={(el) => {
                                            dropdownRefs.current[fieldKey] = el;
                                        }}
                                        className="curved-table-filters-dropdown-inner"
                                    >
                                        {values.map((_ele: string, index: number) => (
                                            <CheckBoxField
                                                key={index}
                                                label={_ele}
                                                onChange={() =>
                                                    _handleChange(
                                                        fieldKey,
                                                        _ele?.toString()?.toLowerCase(),
                                                    )
                                                }
                                                value={(filteredData[fieldKey] || [])?.includes(
                                                    _ele?.toString()?.toLowerCase(),
                                                )}
                                                setSize={values.length}
                                                posInSet={index + 1}
                                            />
                                        ))}
                                    </div>
                                </fieldset>
                            </SwipeableDrawer>
                        </React.Fragment>
                    );
                })}
                {enableSearch && (
                    <>
                        <SearchInput
                            darkmode={true}
                            placeholder={dashboard.ChangeDividend.searchByAMC}
                            value={filteredData['searchKey'] || ''}
                            onChange={(e: any) =>
                                setFilteredData({ ...filteredData, searchKey: e.target.value })
                            }
                        />
                        <div
                            role="status"
                            aria-live="polite"
                            aria-atomic="true"
                            style={{
                                position: 'absolute',
                                left: '-10000px',
                                width: '1px',
                                height: '1px',
                                overflow: 'hidden',
                            }}
                        >
                            {searchAnnouncement}
                        </div>
                    </>
                )}
            </div>
            {!!Object.keys(filteredData)
                .filter((key: string) => key !== 'searchKey')
                .some((_ele: any) => !!filteredData[_ele].length) && (
                <div className="curved-table-filters-selected">
                    <div className="curved-table-filters-selected-tags">
                        {Object.keys(filteredData).length ? (
                            <p>{dashboard.ChangeDividend.selectedFilters}</p>
                        ) : (
                            <React.Fragment />
                        )}
                        <div className="tags">{FilterChips()}</div>
                    </div>
                    {Object.keys(filteredData).length ? (
                        <div className="curved-table-filters-remove">
                            <a
                                role="button"
                                tabIndex={0}
                                onClick={onClear}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        onClear();
                                    }
                                }}
                            >
                                {dashboard.ChangeDividend.removeFilter}
                            </a>
                        </div>
                    ) : (
                        <React.Fragment />
                    )}
                </div>
            )}
        </div>
    );
}
